const tokenName = 'token'
const baseURL = 'http://www.grandlisboavip.net:8899'

export default {
  tokenName,
  baseURL
}